import { freeUserUpgradeStep } from '../utils';

export const findDonationsFoodMoverTour = {
  tourKey: 'find_donations_food_mover',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: ['foodMover'],
  },
  steps: [
    {
      title: 'tours.find-donations.welcome.title',
      content: 'tours.find-donations-food-mover.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="view-toggle"]',
      title: 'tours.find-donations.view-toggle.title',
      content: 'tours.find-donations.view-toggle.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="map-view-btn"]',
      title: 'tours.find-donations.map-view.title',
      content: 'tours.find-donations.map-view.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="table-view-btn"]',
      title: 'tours.find-donations.table-view.title',
      content: 'tours.find-donations.table-view.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="donations-list"]',
      title: 'tours.find-donations.list.title',
      content: 'tours.find-donations-food-mover.list.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
